export default {
  filters: {
    segment_color: function (value) {
      switch (value) {
        case 'photographer':
          return '#d74061'
        case 'family':
          return '#34c1e2'
        case 'portrait':
          return '#FFB300'
        case 'sports':
          return '#009688'
        case 'filmmaker':
          return '#7c3fa6'
        default:
          return '#000'
      }
    },
    segment_icon: function (value) {
      switch (value) {
        case 'photographer':
          return 'favorite'
        case 'family':
          return 'child_care'
        case 'portrait':
          return 'face'
        case 'sports':
          return 'sports_soccer'
        case 'filmmaker':
          return 'videocam'
        default:
          return 'image'
      }
    },
    awards_media_type_icon: function (value) {
      switch (value) {
        case 'photo':
        case 'image_upload':
          return 'panorama'
        case 'film':
        case 'video_link':
          return 'movie'
        case 'collection':
        case 'photo_album':
          return 'photo_library'
        default:
          return 'image'
      }
    }
  }
}